import { Component, Input } from '@angular/core';
import { APIInformationCard } from 'src/app/model/card/api-information-card';

import { documentToHtmlString } from '.';

@Component({
  selector: 'app-api-information-card',
  templateUrl: './api-information-card.component.html',
  styleUrls: ['./api-information-card.component.scss']
})
export class APIInformationCardComponent {
  @Input() apiInformation: APIInformationCard[] = [];
  constructor() {}

  returnHtmlFromRichText(richText: any): string {
    if (richText === undefined || richText === null || richText.nodeType !== 'document') {
      return '<p>Error</p>';
    }

    return documentToHtmlString(richText);
  }
}
